import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../app.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PaginationService } from '../PaginationService';
import { messageService } from '../message.service';
import { AuComponent } from '../qms/au/au.component';
import { AuService } from '../qms/au/au.service';
import { qmsService } from '../qms/qms.service';

@Component({
  selector: 'app-file-launch',
  templateUrl: './file-launch.component.html',
  styleUrls: ['./file-launch.component.scss']
})
export class FileLaunchComponent implements OnInit {
  id: string | null;
  loading: boolean;
  isProcessing: any = false;
  dataSource: any;

  visibleConfirmFinding: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmFindingPopup', { static: true }) confirmFindingPopup: TemplateRef<any>;

  confirmFindingPopupConfig = {
    width: '90%',
    height: '85%',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  dropDownForOwner: any = [];
  @ViewChild('addPopup', { static: true }) addPopup: TemplateRef<any>;
  visibleAddPopup: MatDialogRef<TemplateRef<any>>;
  addPopupConfig = {
    width: '50%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };
  constructor(private route: ActivatedRoute, private appService: AppService, private snackBar: MatSnackBar, private router: Router,
    public dialog: MatDialog, public paginationService: PaginationService,
    public qmsservice: qmsService, public message: messageService,
    public auService: AuService, public auComponent: AuComponent
  ) { }
  ownerListDropdown: any = [];
  selectBoxForOwner() {
    this.ownerListDropdown = [];
    for (let j = 0; j < this.dropDownForOwner.length; j++) {
      this.ownerListDropdown = this.ownerListDropdown.concat({
        valueExp: this.dropDownForOwner[j].userId,
        displayExp: this.dropDownForOwner[j].userName
      });
    }
  }
  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('details');
    console.log(this.id);

    const datainput = {
      "encodedcode": this.id
    }
    this.appService.decryptPassword(datainput).subscribe((data: any) => {

      let decodeddata = data.result.split("-");

      let dataForUsercheck = {

        "module": decodeddata[2],
        "redId": decodeddata[3],
        "version": decodeddata[4],
        "subrefType": decodeddata[5],
        "subrefId": decodeddata[6]
      }

      this.appService.validateUserForEmail(dataForUsercheck).subscribe((data: any) => {

        if (data.resultType == 'S' || data.RESULT_TYPE_KEY == 'E') {
          if (data.resultType == "S") {
            sessionStorage.setItem('isvalisatePage', 'Y')
            sessionStorage.setItem('groupid', data.groupId);
            sessionStorage.setItem('crNo', decodeddata[3]);
            let mytask = {
              "moduleCode": decodeddata[2],
              "taskNo": decodeddata[3],
              "version": decodeddata[4],
              "subModuleName": decodeddata[5] == "NA" ? null : decodeddata[5],
              "subTaskNo": decodeddata[6]
            }
            if (decodeddata[1] == 'eMail') {
              this.router.navigate(['/dashboard/MyTasks']);

            } else {
              this.openAddPopup(mytask);
            }

          }

        } else {


          this.appService.orgDetailsVyid(dataForUsercheck).subscribe((data: any) => {



            window.location.href = data.applicationUrl


          });


        }
        this.loading = false;
      })
    })
  }
  dropDownForAuditGroup: any;

  popupDataTitle: any;
  selectedOwner: any = [];
  ecData: any = {};
  selectedCheckRequiredFor: any = [];
  selectedCheckRequiredForDisplayExp: any = [];
  selectedCheckRequiredForValueExp: any = [];
  openAddPopup(data: any) {

    this.isProcessing = true;
    this.message.taskLevelData = {};
    this.qmsservice.cancelButtonFrom = "myTask";
    this.qmsservice.taskModuleName = data.moduleCode;
    this.qmsservice.moduleName = data.moduleCode;
    if (data.moduleCode == 'CR') {
      this.appService.getCrByCrNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';

        this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
          this.qmsservice.userRole = response1;

          if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
            this.qmsservice.loggedInitiaor = true;
          } else {
            this.qmsservice.loggedInitiaor = false;
          }
          this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Effectiveness Check Performer').subscribe((data1: any) => {
            this.dropDownForOwner = data1;
            this.selectBoxForOwner();

            if (data.subModuleName != null) {
              if (data.subTaskName.includes("-")) {
                // let temp1 = data.subTaskName.split("-");
                // temp1 = temp1[1].replace(/\s/g, "");
              };
            }
            let checkReqForValue;
            if (data.subTaskName != null) {
              if (data.subTaskName.includes("-")) {

                checkReqForValue = data.subTaskName.split("- ");
                console.log(checkReqForValue[1]);
              };
            }

            this.qmsservice.activityId = data.taskNo;
            this.message.activityId = data.taskNo;
            this.qmsservice.moduleName = data.moduleCode;
            if (data.status == "Closed(Effectiveness Check Pending)") {
              this.popupDataTitle = "Create Effectiveness Check";
              this.selectedCheckRequiredFor = [];
              this.selectedOwner = [];
              this.ecData.dueDate = null;
              this.ecData.remindNDaysBeforeDueDate = '';
              this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
            } else if (data.subModuleName == 'Effectiveness Check') {
              this.message.taskLevelData = {
                EC_ID: data.subTaskNo,
                CHECK_REQD_FOR: checkReqForValue[1],
                subModuleName: data.subModuleName,
                REF_NO: this.qmsservice.activityId
              }
            } else if (data.subModuleName == 'Actions') {
              this.message.taskLevelData = {
                ACTION_ID: data.subTaskNo,
                subModuleName: data.subModuleName
              }
            } else if (data.subModuleName == 'Extension') {
              this.message.taskLevelData = {
                REF_NO: this.qmsservice.activityId,
                EXTENSION_ID: data.subTaskNo,
                subModuleName: data.subModuleName
              }
            }
            if (data.subModuleName == null && data.status != "Closed(Effectiveness Check Pending)") {
              this.message.breadcrumbData.thirdLevel = this.message.breadcrumbData.thirdLevel//+" ("+list.CR_ID+")";
              this.message.breadcrumbData.fourthLevel = data.taskId;
              this.router.navigate(['dashboard/qmsCr']);
            }

            this.isProcessing = false;

          });
        });
      });
    } else if (data.moduleCode == 'DV') {
      this.appService.getDvByDvNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';
        this.appService.getQmsGroupDetailsByModule(response.groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
          this.qmsservice.selectedGroupDetailData = data1;
          this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            this.qmsservice.userRole = response1;
            this.isProcessing = false;
            if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
              this.qmsservice.loggedInitiaor = true;
            } else {
              this.qmsservice.loggedInitiaor = false;
            }

            this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Effectiveness Check Performer').subscribe((data1: any) => {
              this.dropDownForOwner = data1;
              this.selectBoxForOwner();

              if (data.subModuleName != null) {
                if (data.subTaskName.includes("-")) {
                  let temp1 = data.subTaskName.split("-");
                  temp1 = temp1[1].replace(/\s/g, "");
                };
              }
              let checkReqForValue;
              if (data.subTaskName != null) {
                if (data.subTaskName.includes("-")) {
                  checkReqForValue = data.subTaskName.split("- ");
                  console.log(checkReqForValue[1]);
                };
              }

              this.qmsservice.activityId = data.taskNo;
              this.message.activityId = data.taskNo;
              this.qmsservice.moduleName = data.moduleCode;
              if (data.status == "Closed(Effectiveness Check Pending)") {
                this.popupDataTitle = "Create Effectiveness Check";
                this.selectedCheckRequiredFor = [];
                this.selectedOwner = [];
                this.ecData.dueDate = null;
                this.ecData.remindNDaysBeforeDueDate = '';
                this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
              } else if (data.subModuleName == 'Effectiveness Check') {
                this.message.taskLevelData = {
                  EC_ID: data.subTaskNo,
                  CHECK_REQD_FOR: checkReqForValue[1],
                  subModuleName: data.subModuleName,
                  REF_NO: this.qmsservice.activityId
                }
              } else if (data.subModuleName == 'Actions') {
                this.message.taskLevelData = {
                  ACTION_ID: data.subTaskNo,
                  subModuleName: data.subModuleName
                }
              } else if (data.subModuleName == 'Extension') {
                this.message.taskLevelData = {
                  REF_NO: this.qmsservice.activityId,
                  EXTENSION_ID: data.subTaskNo,
                  subModuleName: data.subModuleName
                }
              }
              if (data.subModuleName == null && data.status != "Closed(Effectiveness Check Pending)") {
                this.message.breadcrumbData.thirdLevel = this.message.breadcrumbData.thirdLevel;
                this.message.breadcrumbData.fourthLevel = data.taskId;
                this.router.navigate(['dashboard/dv']);
              }

            });

          });

        });

      });
    } else if (data.moduleCode == 'CAPA') {
      this.appService.getCapaVwDetailsByCapaNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';

        this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
          this.qmsservice.userRole = response1;
          this.isProcessing = false;

          if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
            this.qmsservice.loggedInitiaor = true;
          } else {
            this.qmsservice.loggedInitiaor = false;
          }

          this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Effectiveness Check Performer').subscribe((data1: any) => {
            this.dropDownForOwner = data1;
            this.selectBoxForOwner();

            if (data.subModuleName != null) {
              if (data.subTaskName.includes("-")) {
                let temp1 = data.subTaskName.split("-");
                temp1 = temp1[1].replace(/\s/g, "");
              };
            }
            let checkReqForValue;
            if (data.subTaskName != null) {
              if (data.subTaskName.includes("-")) {
                checkReqForValue = data.subTaskName.split("- ");
                console.log(checkReqForValue[1]);
              };
            }

            this.qmsservice.activityId = data.taskNo;
            this.message.activityId = data.taskNo;
            this.qmsservice.moduleName = data.moduleCode;

            if (data.status == "Closed(Effectiveness Check Pending)") {
              this.popupDataTitle = "Create Effectiveness Check";
              this.selectedCheckRequiredFor = [];
              this.selectedOwner = [];
              this.ecData.dueDate = null;
              this.ecData.remindNDaysBeforeDueDate = '';
              this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
            } else if (data.subModuleName == 'Effectiveness Check') {
              this.message.taskLevelData = {
                EC_ID: data.subTaskNo,
                CHECK_REQD_FOR: checkReqForValue[1],
                subModuleName: data.subModuleName,
                REF_NO: this.qmsservice.activityId
              }
            } else if (data.subModuleName == 'Actions') {
              this.message.taskLevelData = {
                ACTION_ID: data.subTaskNo,
                subModuleName: data.subModuleName
              }
            } else if (data.subModuleName == 'Extension') {
              this.message.taskLevelData = {
                REF_NO: this.qmsservice.activityId,
                EXTENSION_ID: data.subTaskNo,
                subModuleName: data.subModuleName
              }
            }
            if (data.subModuleName == null && data.status != "Closed(Effectiveness Check Pending)") {
              this.message.breadcrumbData.thirdLevel = this.message.breadcrumbData.thirdLevel;
              this.message.breadcrumbData.fourthLevel = data.taskId;
              this.router.navigate(['dashboard/capa']);
            }

          });
        });
      });
    } else if (data.moduleCode == 'IN') {
      this.appService.getIncidentDetailsByInNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';
        this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
          if (response1.length > 0) {
            this.qmsservice.userRole = response1;
            this.qmsservice.selectedGroupDetailId = response1[0].groupDetailId;
            this.isProcessing = false;

            if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
              this.qmsservice.loggedInitiaor = true;
            } else {
              this.qmsservice.loggedInitiaor = false;
            }


          }
          if (data.subModuleName != null) {
            if (data.subTaskName.includes("-")) {
              let temp1 = data.subTaskName.split("-");
              temp1 = temp1[1].replace(/\s/g, "");
            };
          }

          let checkReqForValue: any;
          if (data.subTaskName != null) {
            if (data.subTaskName.includes("-")) {
              checkReqForValue = data.subTaskName.split("- ");
              console.log(checkReqForValue[1]);
            };
          }

          this.qmsservice.activityId = data.taskNo;
          this.message.activityId = data.taskNo;
          this.qmsservice.moduleName = data.moduleCode;
          if (data.subModuleName == 'Effectiveness Check') {
            this.message.taskLevelData = {
              EC_ID: data.subTaskNo,
              CHECK_REQD_FOR: checkReqForValue[1],
              subModuleName: data.subModuleName,
              REF_NO: this.qmsservice.activityId
            }
          } else if (data.subModuleName == 'Actions') {
            this.message.taskLevelData = {
              ACTION_ID: data.subTaskNo,
              subModuleName: data.subModuleName
            }
          } else if (data.subModuleName == 'Extension') {
            this.message.taskLevelData = {
              REF_NO: this.qmsservice.activityId,
              EXTENSION_ID: data.subTaskNo,
              subModuleName: data.subModuleName
            }
          }
          if (data.subModuleName == null) {
            this.message.breadcrumbData.fourthLevel = data.taskId;
            this.router.navigate(['dashboard/in']);
          }
        });
      });
    } else if (data.moduleCode == 'QI') {
      this.appService.getQiVwDetailsByQiNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';

        this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
          this.qmsservice.userRole = response1;
          this.qmsservice.selectedGroupDetailId = response1[0].groupDetailId;
          this.isProcessing = false;

          if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
            this.qmsservice.loggedInitiaor = true;
          } else {
            this.qmsservice.loggedInitiaor = false;
          }

          if (data.subModuleName != null) {
            if (data.subTaskName.includes("-")) {
              let temp1 = data.subTaskName.split("-");
              temp1 = temp1[1].replace(/\s/g, "");
            };
          }

          let checkReqForValue: any;
          if (data.subTaskName != null) {
            if (data.subTaskName.includes("-")) {
              checkReqForValue = data.subTaskName.split("- ");
              console.log(checkReqForValue[1]);
            };
          }

          this.qmsservice.activityId = data.taskNo;
          this.message.activityId = data.taskNo;
          this.qmsservice.moduleName = data.moduleCode;

          this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Effectiveness Check Performer').subscribe((data1: any) => {
            this.dropDownForOwner = data1;
            this.selectBoxForOwner();
          })

          if (data.status == "Closed(Effectiveness Check Pending)") {
            this.popupDataTitle = "Create Effectiveness Check";
            this.selectedCheckRequiredFor = [];
            this.selectedOwner = [];
            this.ecData.dueDate = null;
            this.ecData.remindNDaysBeforeDueDate = '';
            this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
          } else if (data.subModuleName == 'Effectiveness Check') {
            this.message.taskLevelData = {
              EC_ID: data.subTaskNo,
              CHECK_REQD_FOR: checkReqForValue[1],
              subModuleName: data.subModuleName,
              REF_NO: this.qmsservice.activityId
            }
          } else if (data.subModuleName == 'Actions') {
            this.message.taskLevelData = {
              ACTION_ID: data.subTaskNo,
              subModuleName: data.subModuleName
            }
          } else if (data.subModuleName == 'Extension') {
            this.message.taskLevelData = {
              REF_NO: this.qmsservice.activityId,
              EXTENSION_ID: data.subTaskNo,
              subModuleName: data.subModuleName
            }
          }
          if (data.subModuleName == null && data.status != "Closed(Effectiveness Check Pending)") {
            this.message.breadcrumbData.fourthLevel = data.taskId;
            this.router.navigate(['dashboard/qi']);
          }
        });
      });
    } else if (data.moduleCode == 'CC') {
      this.appService.getCcDetailsByCcNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';
        this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
          this.qmsservice.userRole = response1;
          this.isProcessing = false;

          if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
            this.qmsservice.loggedInitiaor = true;
          } else {
            this.qmsservice.loggedInitiaor = false;
          }

          if (data.subModuleName != null) {
            if (data.subTaskName.includes("-")) {
              let temp1 = data.subTaskName.split("-");
              temp1 = temp1[1].replace(/\s/g, "");
            };
          }

          let checkReqForValue: any;

          if (data.subTaskName != null) {
            if (data.subTaskName.includes("-")) {
              checkReqForValue = data.subTaskName.split("- ");
              console.log(checkReqForValue[1]);
            };
          }

          this.qmsservice.activityId = data.taskNo;
          this.message.activityId = data.taskNo;
          this.qmsservice.moduleName = data.moduleCode;
          if (data.subModuleName == 'Effectiveness Check') {
            this.message.taskLevelData = {
              EC_ID: data.subTaskNo,
              CHECK_REQD_FOR: checkReqForValue[1],
              subModuleName: data.subModuleName,
              REF_NO: this.qmsservice.activityId
            }
          } else if (data.subModuleName == 'Actions') {
            this.message.taskLevelData = {
              ACTION_ID: data.subTaskNo,
              subModuleName: data.subModuleName
            }
          } else if (data.subModuleName == 'Extension') {
            this.message.taskLevelData = {
              REF_NO: this.qmsservice.activityId,
              EXTENSION_ID: data.subTaskNo,
              subModuleName: data.subModuleName
            }
          }
          if (data.subModuleName == null) {
            this.message.breadcrumbData.fourthLevel = data.taskId;
            this.router.navigate(['dashboard/cc']);
          }
        });
      });
    } else if (data.moduleCode == 'AU') {
      this.qmsservice.activityId = this.message.activityId = data.taskNo;
      this.auService.auditPageFrom = "MyTask";
      this.qmsservice.auditEditmodeDatas = { pageName: "" };
      if (data.subModuleName == 'Extension') {
        this.message.taskLevelData = {
          REF_NO: this.qmsservice.activityId,
          EXTENSION_ID: data.subTaskNo,
          subModuleName: data.subModuleName
        }
      } else if (data.subModuleName == 'Findings') {
        this.isProcessing = false;
        this.qmsservice.activityDynamicButtonList = [];
        this.auService.tabName = 'Conduct Audit';
        this.auService.findingId = data.subTaskNo;

        this.qmsservice.moduleName = "AU";
        this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
        //this.auComponent.ngOnInit();
        this.qmsservice.cancelButtonFrom = "myTask";
        this.appService.getAuByAuNo(this.qmsservice.activityId).subscribe((data: any) => {

          this.appService.getQmsActiveUserByGroupIdModuleUserId(data.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            this.qmsservice.userRole = response1;

            if (this.qmsservice.userRole[0]?.qmsRoles.includes("Auditor")) {
              this.qmsservice.loggedAuditor = true;
            } else {
              this.qmsservice.loggedAuditor = false;
            }

            this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
            let list: any = {};
            this.message.activityId = this.qmsservice.activityId = list.AU_NO = data.auNo;
            this.qmsservice.selectedActivityGroupId = list.GROUP_ID = data.groupId;
            this.qmsservice.selectedGroup = data.groupId;
            this.message.breadcrumbData.fourthLevel = list.AU_ID = data.auId;
            this.qmsservice.activity = {};
            this.qmsservice.activity.status = list.STATUS = data.status;
            this.qmsservice.getQmsActionDataUsingById = {};
            this.visibleConfirmFinding = this.dialog.open(this.confirmFindingPopup, this.confirmFindingPopupConfig);

          });

        })



      } else if (this.auService.auditScheduleStatusList.indexOf(data.status) != -1) {
        this.auService.tabName = "Annual Audit Schedule";
        this.isProcessing = false;
        this.appService.getAuByAuNo(this.qmsservice.activityId).subscribe((data: any) => {
          //this.qmsservice.auditEditmodeDatas = { pageName: this.selectedTab };

          this.auService.list = {};
          this.message.activityId = this.qmsservice.activityId = this.auService.list.AU_NO = data.auNo;
          this.qmsservice.selectedActivityGroupId = this.auService.list.GROUP_ID = data.groupId;
          this.message.breadcrumbData.fourthLevel = this.auService.list.AU_ID = data.auId;
          this.qmsservice.activity = {};
          this.qmsservice.activity.status = this.auService.list.STATUS = data.status;
          this.qmsservice.getQmsActionDataUsingById = {};
          this.appService.getQmsGroupsByModule("AU").subscribe((response1: any) => {
            this.dropDownForAuditGroup = response1;
            this.auService.priorGroup = this.dropDownForAuditGroup.find((item: any) => item.groupId == data.groupId);
            this.qmsservice.auditEditmodeDatas = { pageName: "Annual Audit Schedule" };
            //this.auComponent.ngOnInit();
            this.isProcessing = false;
          });
          this.isProcessing = false;
        });

      } else if (data.status.includes("Initiated")) {
        this.isProcessing = false;
        this.qmsservice.activityDynamicButtonList = [];
        this.auService.tabName = 'Conduct Audit';
        this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
        //this.auComponent.ngOnInit();
        this.qmsservice.cancelButtonFrom = "myTask";
        this.appService.getAuByAuNo(this.qmsservice.activityId).subscribe((data: any) => {

          this.appService.getQmsActiveUserByGroupIdModuleUserId(data.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            this.qmsservice.userRole = response1;

            if (this.qmsservice.userRole[0]?.qmsRoles.includes("Auditor")) {
              this.qmsservice.loggedAuditor = true;
            } else {
              this.qmsservice.loggedAuditor = false;
            }

            this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
            let list: any = {};
            this.message.activityId = this.qmsservice.activityId = list.AU_NO = data.auNo;
            this.qmsservice.selectedActivityGroupId = list.GROUP_ID = data.groupId;
            this.message.breadcrumbData.fourthLevel = list.AU_ID = data.auId;
            this.qmsservice.activity = {};
            this.qmsservice.activity.status = list.STATUS = data.status;
            this.qmsservice.getQmsActionDataUsingById = {};
            this.router.navigate(['/dashboard/auDetailPage']);

          });

        })

      } else if (this.auService.auditPlanStatusList.indexOf(data.status) != -1) {
        this.auService.tabName = "Audit Plan";
        this.appService.getAuByAuNo(this.qmsservice.activityId).subscribe((data: any) => {
          this.appService.getQmsActiveUserByGroupIdModuleUserId(data.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            this.qmsservice.userRole = response1;

            if (this.qmsservice.userRole[0]?.qmsRoles.includes("Auditor")) {
              this.qmsservice.loggedAuditor = true;
            } else {
              this.qmsservice.loggedAuditor = false;
            }

            this.auService.list = {};
            this.message.activityId = this.qmsservice.activityId = this.auService.list.AU_NO = data.auNo;
            this.qmsservice.selectedActivityGroupId = this.auService.list.GROUP_ID = data.groupId;
            this.message.breadcrumbData.fourthLevel = this.auService.list.AU_ID = data.auId;
            this.qmsservice.activity = {};
            this.qmsservice.activity.status = this.auService.list.STATUS = data.status;
            this.qmsservice.getQmsActionDataUsingById = {};
            this.appService.getQmsGroupsByModule("AU").subscribe((response1: any) => {
              this.dropDownForAuditGroup = response1;

              this.auService.priorGroup = this.dropDownForAuditGroup.find((item: any) => item.groupId == data.groupId);
              this.qmsservice.auditEditmodeDatas = { pageName: "Audit Plan" };
              //this.auComponent.ngOnInit();
              this.isProcessing = false;
            });
            this.isProcessing = false;

          });

        });
        this.isProcessing = false;
      } else {
        this.isProcessing = false;
        this.qmsservice.activityDynamicButtonList = [];
        this.auService.tabName = 'Conduct Audit';
        this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
        //this.auComponent.ngOnInit();
        this.qmsservice.cancelButtonFrom = "myTask";
        this.appService.getAuByAuNo(this.qmsservice.activityId).subscribe((data: any) => {

          this.appService.getQmsActiveUserByGroupIdModuleUserId(data.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            this.qmsservice.userRole = response1;

            if (this.qmsservice.userRole[0]?.qmsRoles.includes("Auditor")) {
              this.qmsservice.loggedAuditor = true;
            } else {
              this.qmsservice.loggedAuditor = false;
            }

            this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
            let list: any = {};
            this.message.activityId = this.qmsservice.activityId = list.AU_NO = data.auNo;
            this.qmsservice.selectedActivityGroupId = list.GROUP_ID = data.groupId;
            this.message.breadcrumbData.fourthLevel = list.AU_ID = data.auId;
            this.qmsservice.activity = {};
            this.qmsservice.activity.status = list.STATUS = data.status;
            this.qmsservice.getQmsActionDataUsingById = {};
            this.router.navigate(['/dashboard/auDetailPage']);

          });

        })

      }
    }
    //this.clickedGidData=data;
    //this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

}
